// to check if url contains the query params
export const checkQueryParams = (url = "", check = "#") => {
  return url?.includes(check);
};
